import { render, staticRenderFns } from "./table-list.vue?vue&type=template&id=cb316d4c&lang=pug"
import script from "./table-list.vue?vue&type=script&lang=js"
export * from "./table-list.vue?vue&type=script&lang=js"
import style0 from "./table-list.vue?vue&type=style&index=0&id=cb316d4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports